module.exports = __webpack_public_path__ + "static/media/IMG_2008.6b6506f3.jpg";